export enum ImplantListColumnId {
  ReferenceOrBarcodeNumber = 'referenceOrBarcodeNumber',
  Description = 'description',
  Expiry = 'expiry',
  BatchLot = 'batchLot',
  Quantity = 'quantity',
  CheckedIn = 'checkedIn',
  CheckedOut = 'checkedOut',
  Dispatched = 'dispatched',
  ImplantKit = 'implantKit',
}

export type ImplantIdFields = {
  label: string;
  implantInstanceId: string;
  deliveryId: string;
  crossDeliveryId?: string;
  surgeryReference: string;
  deliveryNumber: string;
  isDeletable: boolean;
};

export const makeImplantIdFields = (data: Partial<ImplantIdFields>): ImplantIdFields => {
  return {
    label: '',
    implantInstanceId: '',
    deliveryId: '',
    crossDeliveryId: '',
    surgeryReference: '',
    deliveryNumber: '',
    isDeletable: false,
    ...data,
  };
};

export type ImplantGroup = {
  sortCode: string;
  label: string;
  foreignGroupLabel: string; // belongs to another delivery/surgery
  implantCheckedInNotDispatched: boolean;
  isSuperfluous: boolean; // not seen before
  members: ImplantIdFields[];
  hasDeletables: boolean;
  implantKitUss?: string;
  implantKitName?: string;
  implantKitCode?: string;
};
